export const schema = {
  // print: ['kitchen',
  //     'bill', // ใบเรียกเก็บเงิน
  //     'receipt', // ใบเสร็จรับเงิน
  //     // 'invoice' // ใบแจ้งหนี้
  // ],
  pos_manage: [
    'coupon',
    // 'promotion', 'special_package',
    'product',
    // 'shift_manage', 'e_menu',
    'branches_manage'
  ],
  payment: [
    'cash',
    'promptpay',
    'credit_card'
    // 'edc', 'point', 'wallet', 'print_qr', 'dynamic_qr', 'shopee_pay', 'beam_payment'
  ],
  // queue_manage: ['run_queue'],
  report: [
    'sales'
    // 'sales_by_type', 'sales_by_category', 'sales_by_payment', 'table_period',
    // 'auto_email', 'dashboard'
  ], // auto mail admin can self set report
  // bill_manage: ['reprint_bill', 'void_bill'],
  // shop_setting: ['service_charge', 'vat'],
  sale_type: ['takeaway', 'dinein', 'delivery', 'openbill']
};

const defaults = {
  // allow_type: {
  //     takeaway: true,
  //     dinein: true,
  // },
  // shop: true
};

const deepFreeze = obj => {
  if (!obj || typeof obj !== 'object' || Object.isFrozen(obj)) return obj;

  Object.freeze(obj);

  for (const key in obj) {
    deepFreeze(obj[key]);
  }

  return obj;
};

const buildBase = (schema, defaults = {}) => {
  const root = {};

  for (const key in schema) {
    const childrenKeys = schema[key];
    const children = {};
    const defaultValue = defaults[key];

    for (let i = 0; i < childrenKeys.length; i++) {
      const childKey = childrenKeys[i];

      let value = false;

      if (defaultValue === true) {
        value = true;
      } else if (defaultValue && typeof defaultValue === 'object') {
        value = !!defaultValue[childKey];
      }

      children[childKey] = { value };
    }

    root[key] = {
      value: false,
      indeterminate: false,
      children
    };
  }

  return root;
};

export const iniData = deepFreeze(buildBase(schema, defaults));
